import './CompactCalendar.css';
export default {
    "compactCalendarContainer": "CompactCalendar_compactCalendarContainer__1qdkh",
    "compactDateGrid": "CompactCalendar_compactDateGrid__1qdkh",
    "compactChoiceCardContainer": "CompactCalendar_compactChoiceCardContainer__1qdkh"
};
